/**
 * Service layer — firm master spec library (admin).
 * Wraps /api/spec-master. All calls carry the Clerk bearer (admin-gated server-side).
 */

const API = '/api/spec-master'

async function call(method, body, qs) {
  const token = await window.__clerkGetToken()
  const url = API + (qs ? '?' + qs : '')
  const res = await fetch(url, {
    method,
    headers: method === 'GET'
      ? { 'Authorization': 'Bearer ' + token }
      : { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
    body: method === 'GET' ? undefined : JSON.stringify(body),
  })
  const j = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(j.error || 'spec-master error: ' + res.status)
  return j
}

/** Load the whole library: { sections, fields, registerItems }. */
export function getMasterLibrary() {
  return call('GET', null, 'what=all')
}

export function upsertMasterSection(section) {
  return call('POST', { action: 'upsertSection', section }).then(d => d.section)
}
export function deleteMasterSection(id) {
  return call('POST', { action: 'deleteSection', id }).then(d => d.ok)
}
export function reorderMasterSections(order) {
  return call('POST', { action: 'reorderSections', order }).then(d => d.ok)
}

// (upsertInputField / deleteInputField removed — AlderSPEC Phase 0: the legacy spec_input_fields
// catalog was dropped; the questionnaire is spec_answer_fields, edited via Claude Code / SQL.)

export function upsertMasterRegisterItem(item) {
  return call('POST', { action: 'upsertRegisterItem', item }).then(d => d.item)
}
export function deleteMasterRegisterItem(id) {
  return call('POST', { action: 'deleteRegisterItem', id }).then(d => d.ok)
}

// ── Master template lines (Round 13 template editor) ──
export function getMasterLines(masterSectionId) {
  if (!masterSectionId) return Promise.resolve([])
  return call('GET', null, 'what=lines&masterSectionId=' + encodeURIComponent(masterSectionId)).then(d => d.lines || [])
}
export function saveMasterLines(masterSectionId, lines) {
  return call('POST', { action: 'saveMasterLines', masterSectionId, lines }).then(d => d.lines || [])
}
export function addMasterLine(masterSectionId, fields, afterSort) {
  return call('POST', { action: 'addMasterLine', masterSectionId, fields, afterSort }).then(d => d.line)
}
export function deleteMasterLine(id) {
  return call('POST', { action: 'deleteMasterLine', id }).then(d => d.ok)
}

export const SECTION_KINDS = ['prose', 'schedule']
